import { render } from "./EbookReformaTributaria.vue?vue&type=template&id=2d10b9e6&scoped=true"
import script from "./EbookReformaTributaria.vue?vue&type=script&lang=js"
export * from "./EbookReformaTributaria.vue?vue&type=script&lang=js"

import "./EbookReformaTributaria.vue?vue&type=style&index=0&id=2d10b9e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d10b9e6"

export default script